import React from 'react';
import Card from './Card';

interface FormSectionProps {
  id: string;
  title: string;
  subtitle?: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ 
  id, 
  title, 
  subtitle,
  headerActions,
  children 
}) => {
  return (
    <div id={id}>
      <Card
        title={title}
        subtitle={subtitle}
        headerActions={headerActions}
      >
        {children}
      </Card>
    </div>
  );
};

export default FormSection;